import { TemplateRef, Type } from '@angular/core';
import { Subscription } from 'rxjs';

import { NecLoadingComponent } from './loading.component';

export class NecLoadingConfig {
  template?: TemplateRef<any> | Type<any>;
  delay?: number;
  minDuration?: number;
  backdrop?: boolean;
  message?: string;
  wrapperClass?: string;
  disableAnimation?: boolean;
  busy: Promise<any> | Subscription | Array<Promise<any> | Subscription>;

  constructor() {
    this.message = 'å è½½ä¸­...';
    this.backdrop = true;
    this.wrapperClass = 'nec-loading-container';
    this.template = NecLoadingComponent;
    this.delay = 0;
    this.minDuration = 0;
    this.disableAnimation = false;
  }
}
